<template>
    <div>
        <h1>{{ $trad.formErrorMessages.fieldMissingMessage }}</h1>
        <section v-for="tab in errorPerTabs" :key="tab.name">
            <h2>{{ tab.name }}</h2>
            <p v-for="(error, index) in tab.errors" :key="`${tab.name}${index}`">- {{ error.value }}</p>
        </section>
        <ClientColorButton @click="close" :inactive-color="true">Ok</ClientColorButton>
    </div>
</template>

<script>
import { addSpacesBetweenWords, capitalize } from "@/utils/string";

export default {
    name: "OverlayErrorMessage",
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    methods: {
        close() {
            this.$emit("close");
        }
    },
    computed: {
        forms() {
            return Object.keys(this.form.$params);
        },
        errorPerTabs() {
            let tabs = [];
            for (const formName of this.forms) {
                const form = this.form[formName]; //general form...

                if (form.$invalid) {
                    const name = addSpacesBetweenWords(formName);
                    let formError = { name, errors: [] };

                    for (const field of Object.keys(form)) {
                        const element = form[field]; // name, logo...
                        if (element.$invalid) {
                            const value = capitalize(addSpacesBetweenWords(field));
                            formError.errors.push({ value });
                        }
                    }
                    tabs.push(formError);
                }
            }
            return tabs;
        }
    }
};
</script>

<style scoped lang="scss">
div {
    padding: 50px;
    text-align: center;
    h1 {
        font-family: "Oswald", sans-serif;
        font-size: 30px;
        text-align: center;
    }
}
section {
    margin: 20px 0;
    > * {
        display: block;
    }
    text-align: left;
    h2 {
        font-family: "Oswald", sans-serif;
        text-transform: capitalize;
        font-size: 20px;
        margin: 0;
    }
    p {
        margin: 2px 0;
    }
}
</style>



// WEBPACK FOOTER //
// OverlayErrorMessage.vue?5c24def0